import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          adminAccountId: Yup.string()
                                                             .required('Please select an admin account'),
                                      });
